import { currentPageType, usesCityPhoneNumber } from "Constants/pageTypes";
import { safeGetItem, safeSetItem } from "Utils/safeLocalStorage";

/* global CustomEvent */

/**
 * The phone a previous page stored, together with the page type it came from.
 * Returns empty values when nothing is stored or the entry is unreadable.
 */
function storedPhone(currentSite) {
  const stored = safeGetItem(`city-${currentSite}`);

  if (!stored) {
    return {};
  }

  try {
    const { phone, phonePageType } = JSON.parse(stored);

    return { phone, phonePageType };
  } catch {
    return {};
  }
}

function setData(cityId, cityName, citySlug, cityPhone, cityLat, cityLng) {
  const currentSite = theme_vars.currentSite.toUpperCase();
  const pageType = currentPageType();

  const hasCoordinates =
    cityLat !== null &&
    cityLat !== undefined &&
    cityLat !== "" &&
    cityLng !== null &&
    cityLng !== undefined &&
    cityLng !== "";

  safeSetItem(
    `cityTerm-${currentSite}`,
    JSON.stringify({
      id: cityId,
      name: cityName,
      slug: citySlug,
      ...(hasCoordinates && {
        latitude: Number(cityLat),
        longitude: Number(cityLng),
      }),
    })
  );

  // The city itself always updates — the contact form and the counselor grid
  // scope themselves to the last city the visitor looked at, whichever vertical
  // they were in. The phone does not: only the funeral vertical has city
  // numbers, so a law or therapy page must leave a stored funeral number
  // alone instead of overwriting it with its own national number.
  const { phone, phonePageType } = usesCityPhoneNumber(pageType)
    ? { phone: cityPhone, phonePageType: pageType }
    : storedPhone(currentSite);

  const cityObj = {
    id: cityId,
    name: cityName,
    phone,
    phonePageType,
  };

  safeSetItem(`city-${currentSite}`, JSON.stringify(cityObj));

  window.dispatchEvent(new CustomEvent("city-storage-updated-event"));
}

const City = {
  askForCurrent() {
    const currentCity = document.getElementById("city-id");
    const isMemorialPage = document.getElementsByClassName(
      "single-lavendla_obituary"
    ).length;
    const isMemorialArchive = document.getElementsByClassName(
      "post-type-archive-lavendla_obituary"
    ).length;
    const isOfferPage = document.getElementsByClassName("single-offers").length;

    if (currentCity || isMemorialArchive || isMemorialPage || isOfferPage) {
      return;
    }

    const currentSite = theme_vars.currentSite.toUpperCase();
    const cityTerm = safeGetItem(`cityTerm-${currentSite}`);

    if (cityTerm || sessionStorage.getItem("hasDoneLocationCheck")) {
      return;
    }

    const success = async (position) => {
      const { latitude, longitude } = position.coords;

      if (sessionStorage.getItem("hasDoneLocationCheck")) {
        return;
      }

      await fetch(
        `${theme_vars.theme_api_url}/get-city-from-long-lat?lat=${latitude}&long=${longitude}`
      )
        .then((response) => response.json())
        .then((data) => {
          const { cityId, cityName, citySlug, cityPhone } = data;

          if (cityId) {
            setData(cityId, cityName, citySlug, cityPhone);
          }

          sessionStorage.setItem("hasDoneLocationCheck", JSON.stringify(true));
        });
    };

    const error = () => {
      sessionStorage.setItem("hasDoneLocationCheck", JSON.stringify(true));
    };

    navigator.geolocation.getCurrentPosition(success, error, {
      enableHighAccuracy: true,
      maximumAge: 0,
      timeout: 15_000,
    });
  },
  getCurrent() {
    const currentCity = document.getElementById("city-id");

    if (!currentCity) {
      return;
    }

    const {
      cityId,
      cityName,
      citySlug,
      cityPhone,
      cityLatitude,
      cityLongitude,
    } = currentCity.dataset;

    setData(cityId, cityName, citySlug, cityPhone, cityLatitude, cityLongitude);
  },

  setData,
};

export default City;
